import { c as _c } from "react/compiler-runtime";
import { useState, type MouseEvent } from "react";
import { stopPropagation } from "./MarketplaceItemPreviewCard.utils";
interface MarketplaceCopyListingButtonProps {
  readonly href: string;
  readonly className: string;
  readonly testId?: string | undefined;
}
export default function MarketplaceCopyListingButton(t0) {
  const $ = _c(11);
  const {
    href,
    className,
    testId
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== href) {
    t1 = event => {
      stopPropagation(event);
      navigator.clipboard.writeText(href).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 500);
      }).catch(_temp);
    };
    $[0] = href;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const copyToClipboard = t1;
  const t2 = copied ? "Listing link copied" : "Copy listing link";
  const t3 = copied ? "#34d399" : "currentColor";
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <svg className="tw-size-3.5 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke={t3} aria-hidden="true">{t4}</svg>;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== className || $[6] !== copyToClipboard || $[7] !== t2 || $[8] !== t5 || $[9] !== testId) {
    t6 = <button type="button" data-testid={testId} className={className} aria-label={t2} onClick={copyToClipboard} onMouseDown={_temp2} onTouchStart={_temp3}>{t5}</button>;
    $[5] = className;
    $[6] = copyToClipboard;
    $[7] = t2;
    $[8] = t5;
    $[9] = testId;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp3(event_1) {
  return event_1.stopPropagation();
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp() {}